import(/* webpackMode: "eager", webpackExports: ["ProfileAvatar"] */ "/home/ubuntu/live/arthaverse-website/components/modules/professionals/profileAvatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/live/arthaverse-website/components/modules/professionals/projectPagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/live/arthaverse-website/components/modules/professionals/requestServiceButton.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/live/arthaverse-website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/live/arthaverse-website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["parseAsBoolean"] */ "/home/ubuntu/live/arthaverse-website/node_modules/nuqs/dist/index.js");
